//region Burger
const openBurger = () => {
  let header_burger = document.querySelector('.header-main__burger');
  let header_menu = document.querySelector('.header-main__menu');
  if (header_burger && header_menu) {
    header_burger.addEventListener('click', function () {
      toggleClass(header_burger, 'js-active');
      toggleClass(header_menu, 'js-active');
    });
  }
}
openBurger();
//endregion

// Change element's classes
const toggleClass = (el, className) => el.classList.toggle(className);

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const getDomainWithoutSubdomain = url => {
  const urlParts = new URL(url).hostname.split('.')

  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join('.')
}

function removeCookie(sKey) {
  const domain = getDomainWithoutSubdomain(window.location);
  document.cookie = sKey + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + domain;
  // console.log('domain', "domain=." + domain);
}

(function ($) {
  $(function () {

    //region App type - add params to all links
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const app_type = urlParams.get('app_type');
    if (app_type && app_type === 'mobile') {
      $("#block-molottery-content a").attr('href', function(index, item) {
        return item + (item.indexOf('?') != -1 ? "&app_type=mobile"  : "?app_type=mobile");
      });
      // Value on Contact us
      $('.createdby').val('mobile');
    }
    //endregion

    $('a[href="#"]').on('click', function (e) {
      e.preventDefault();
    });

    // FAQ
    $('.faq__title').on('click', function () {
      $(this).toggleClass('js-active').next('.faq__body').slideToggle();
    });

    // News page
    $('.news__archives .views-exposed-form .form-radios').on('click', 'label', function () {
      var $label = $(this).text();
      window.location = "?year=" + $label;
    });

    //region Menu auth items
    var menuLogout = $('.menu-logout');
    menuLogout.parent().hide();
    if (getCookie('AuthToken')) {
      $('.menu-login').parent().hide();
      menuLogout.parent().show();
    }
    menuLogout.on('click', function () {
      removeCookie('AuthToken');
      // console.log('cookie', getCookie('AuthToken'));
      location.reload(true);
    });
    //endregion

    // Logout
    $('.action-logout').on('click', function (e) {
      e.preventDefault();
      removeCookie('AuthToken');
      location.reload(true);
    });

    // Collapsible blocks
    $('.collapsible__title').on('click', function () {
      var $this = $(this);
      $this.next('.collapsible__body').slideToggle('fast');
      $this.toggleClass('js-hidden')
    });

    //region Download file by click
    $('.bordered-blocks__item_logo, .bordered-blocks__item_download, .bordered-blocks__item').on('click', function (e) {

      if ($(this).hasClass('contextual-region')){
        return;
      }

      let url;
      let filename;

      if ($(this).find('.pdfpreview-image-wrapper a').length) {
        url = $(this).find('.pdfpreview-image-wrapper a').attr('href');
      }

      if ($(this).find('.file--mime-application-postscript a').length) {
        url = $(this).find('.file--mime-application-postscript a').attr('href');
      }

      if (!url) {
        if ($(this).find('.field--name-field-bblock-logo img').length) {
          url = $(this).find('.field--name-field-bblock-logo img').attr('src');
        }
        if ($(this).find('.bordered-blocks__link a[href$=".pdf"]').length) {
          url = $(this).find('.bordered-blocks__link a').attr('href');
        }
      }

      if (url) {
        e.preventDefault();
        filename = url.substring(url.lastIndexOf('/') + 1);

        let link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        link.remove();
      }
      else {
        // console.error('File not found');
        window.location.href = $(this).attr('href');
      }


    }).children('.contextual').on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    $('.pdf-download').on('click', function (e) {
      if ($(this).hasClass('contextual-region')){
        return;
      }

      let url;
      let filename;
      url = $(this).attr('href')

      if (url) {
        e.preventDefault();

        filename = url.substring(url.lastIndexOf('/') + 1);

        let link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        link.remove();
      }
      else {
        // console.error('File not found here');
        window.location.href = $(this).attr('href');
      }
    }).children('.contextual').on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    //endregion



  });
})(jQuery);

// get parent of element
function closest(el, selector, stopSelector) {
  var retval = null;
  while (el) {
    if (el.className.indexOf(selector) > -1) {
      retval = el;
      break
    }
    else if (stopSelector && el.className.indexOf(stopSelector) > -1) {
      break
    }
    el = el.parentElement;
  }
  return retval;
}
